export default {
	filtro: {
		numeroPedido: {
			default: null,
			label: 'Pesquisa',
			value: null,
		},
	},
	collapse: {
		idOrgao: null,
	},
}
